import clsx from "clsx";

type Props = {
	/** Without a message, the card shows the load. */
	message?: string;
	className?: string;
};

// The card for the load, the empty list and a failed read. It has the head line and the two value rows of
// the project card, so it has the same height, and the row does not jump when the cards arrive. With a
// message, the rows stay in the layout but are invisible, and the message covers the card.
export function ProjectCardPlaceholder({ message, className }: Props) {
	return (
		<li className={clsx("relative flex min-w-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white", className)}
			aria-busy={!message}>
			<div className={clsx("flex flex-col", message ? "invisible" : "animate-pulse")}
				 aria-hidden>
				<div className="flex items-center gap-3 border-b border-gray-200 bg-gray-50 px-3 py-2.5">
					<div className="size-9 shrink-0 rounded-full bg-gray-200" />
					<div className="flex min-h-8 flex-1 items-center">
						<div className="h-3 w-2/3 rounded bg-gray-200" />
					</div>
				</div>
				<div className="flex flex-col gap-1 px-3 py-2.5 text-sm">
					{[0, 1].map((row) => (
						// The row has the 20 px of a `text-sm` value line, the same as the rows of the project card.
						<div key={row} className="flex h-5 items-center justify-between gap-3">
							<div className="h-3 w-1/2 rounded bg-gray-200" />
							<div className="h-3 w-8 rounded bg-gray-200" />
						</div>
					))}
				</div>
			</div>
			{message && (
				<p className="absolute inset-0 flex items-center justify-center p-3 text-center text-sm text-gray-500">
					{message}
				</p>
			)}
		</li>
	);
}
